module.exports = __webpack_public_path__ + "static/dhs-e5ba97972d0a68d851b385286ba551bd.png";